import { loadDemoActivities } from "@/data/demo/demoStore";
import type {
  CalendarActivity,
  CalendarQueryOpts,
} from "@/types/calendar.types";
import { applyBasicFilters } from "@/utils/demo.utils";

export async function fetchCalendarActivitiesDemo(
  q: CalendarQueryOpts,
): Promise<CalendarActivity[]> {
  const all = await loadDemoActivities();
  const rows = applyBasicFilters(all, q);
  return rows.map((a) => ({
    strava_activity_id: a.strava_activity_id,
    start_date: a.start_date!,
    name: a.name,
    type: a.type,
    sport_type: a.sport_type,
    distance: a.distance,
    moving_time: a.moving_time,
    total_elevation_gain: a.total_elevation_gain,
  })) as CalendarActivity[];
}
